import React, { useEffect, useState, useCallback,useRef } from "react";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useSwipeable } from "react-swipeable";
import { ProjectGet } from "../../api/orgService";
import useApi from "../../api/useApi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { Box, Typography, Grid, Card, CardMedia, CardContent, Button, Chip, CircularProgress } from "@mui/material";



const COLORS = {
  primary: "#1D3A89",
  secondary: "#D7A9A4",
  accent: "#c18078",
};



export default function ProjectGrid({fetchProjects }) {

  const navigate = useNavigate()


  const [projects,setAllProjects] = useState([])
  const { request: getAllProjects, data:projectData, error:projectError} = useApi(ProjectGet);
  
  
  const [activeIndex, setActiveIndex] = useState(projects.length - 1); // Start at the top

  const canGoNext = activeIndex < projects.length - 1;
  const canGoPrev = activeIndex > 0;

  const next = useCallback(() => {
    if (canGoNext) {
      setActiveIndex((prev) => prev + 1);
    }
  }, [canGoNext]);

  const prev = useCallback(() => {
    if (canGoPrev) {
      setActiveIndex((prev) => prev - 1);
    }
  }, [canGoPrev]);

  // ⌨️ Keyboard support
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [prev, next]);

  // 🤏 Swipe support
  const handlers = useSwipeable({
    onSwipedLeft: () => next(),  // swipe left → go forward
    onSwipedRight: () => prev(), // swipe right → go back
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });


  useEffect(() => {
    getAllProjects();
         // eslint-disable-next-line
    }, []);
    
    useEffect(()=>{
      if (projectData?.status===200) {
        setAllProjects(projectData?.data?.results);
        setActiveIndex(projectData?.data?.results?.length - 1)
      }
    // eslint-disable-next-line
    },[projectData])

    

    // useEffect(()=>{
    //     if(location?.state?.refresh==="org"){
    //       getAllProjects();
    //     }
    //   // eslint-disable-next-line
    //   },[location?.state])
  
    useEffect(()=>{
        if(projectError){
            toast.error(`${JSON.stringify(projectError?.response?.data,null,2)}`,{position: "top-center"});
      }
    },[projectError])

    const [projectss, setProjects] = useState(projectData?.results || []);
  const [nextPage, setNextPage] = useState(projectData?.next);
  const [loading, setLoading] = useState(false);
  const observerRef = useRef();

  // Infinite scroll
  const loadMore = useCallback(async () => {
    if (!nextPage || loading) return;
    setLoading(true);
    try {
      const res = await fetchProjects(nextPage);
      setProjects((prev) => [...prev, ...(res.results || [])]);
      setNextPage(res.next);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [nextPage, loading, fetchProjects]);

  const lastProjectRef = useCallback(
    (node) => {
      if (loading) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) loadMore();
      });
      if (node) observerRef.current.observe(node);
    },
    [loading, loadMore]
  );

  return (
    <div className="projects-container">
<h2 className="projects-title">Our Projects</h2>
<div className="projects-grid">
{projects?.map((project) => (
<div key={project.id} className="project-card">
<div className="project-image-wrapper">
<img
src={project.image}
alt={project.title}
className="project-image"
/>
</div>


<div className="project-content">
<h3 className="project-name">{project.name}</h3>
<p className="project-excerpt">
{project.story?.slice(0, 140)}...
</p>
<Link
  to={`/projects/${project?.name}/${project?.id}/`}
  state={{ projectId: project?.id, projectName: project?.name,subcategory: project?.subcategory }}
  // className="campaign-btn inline-block text-white bg-blue-600 px-4 py-2 rounded-md hover:bg-blue-700"
  style={{
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    backgroundColor: "#22C55E", // green
    color: "white",
    padding: "10px 20px",
    borderRadius: "9999px",
    fontWeight: "600",
    fontSize: "16px",
    border: "none",
    cursor: "pointer",
    transition: "background-color 0.2s ease"
  }}
  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#c18078")} // blue-600
  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#22C55E")} // green
  >
View More →
</Link>
</div>
</div>
))}
</div>
</div>
);
};